// `lg` is the hero tier — the prominent landing-page search bar and the
// control paired beside it. Not for dense list/table chrome.
export const CONTROL_HEIGHT = {
    sm: 28,
    md: 36,
    lg: 48,
};
//# sourceMappingURL=sizing.js.map